import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d303Api, QueryParams, ReportRow, UnitSummary, VendorCount } from '../../../services/d303Api';

export function useD303Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [groupCounts, setGroupCounts] = useState<VendorCount[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d303Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setUnitSummary(resp.unit_summary || []);
        setGroupCounts(resp.group_counts || []);
        setNoData(false);
      } else {
        setData([]);
        setUnitSummary([]);
        setGroupCounts([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setUnitSummary([]);
    setGroupCounts([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, unitSummary, groupCounts, queried, noData, runQuery, reset };
}
